import { useMemo } from "react";
import { Flex, Table } from "antd";
import { StatusLabel, ActionButton } from "ui";
import { useAppStore } from "store";
import { useMagHomeManagementStore } from "pages/mag-home-management/store";
import {
  useDeleteHomeProduct,
  useGetHomeProducts,
} from "pages/mag-home-management/api";
import { MAG_HOME_PRODUCTS_COLUMN } from "pages/mag-home-management/constant";
import { homeProduct } from "pages/mag-home-management/type";

const HomeProductsTable = () => {
  const setModalVisibility = useAppStore((state) => state.setModalVisibility);
  const { setFormData, setIsEdit } = useMagHomeManagementStore(
    (state) => state
  );

  const { data, isPending } = useGetHomeProducts();
  const { mutate: deleteHomeProductMutation } = useDeleteHomeProduct();

  const dataSource = useMemo(() => {
    return (
      (data?.data ?? [])
        .sort(
          (i1: homeProduct, i2: homeProduct) =>
            (i1.priority ?? 0) - (i2.priority ?? 0)
        )
        .map((item: homeProduct, index: number) => {
          return {
            key: item.id,
            index: (
              <strong className="color-primary text-center">{index + 1}</strong>
            ),
            title: (
              <Flex vertical align="start" gap="5px">
                <strong className="color-primary">
                  {item?.productName ?? "-"}
                </strong>
                <label className="color-stroke">
                  شناسه: {item?.productId ?? "-"}
                </label>
              </Flex>
            ),
            priority: (
              <strong className="color-primary text-center">
                {item?.priority ?? "0"}
              </strong>
            ),
            status: (
              <Flex align="center" justify="center">
                <StatusLabel status={item.isActive} />
              </Flex>
            ),
            action: (
              <Flex gap={8} justify="center">
                <ActionButton
                  type="remove"
                  onClick={() => deleteHomeProductMutation(item.id!)}
                />
                <ActionButton
                  type="edit"
                  onClick={() => {
                    setFormData(item);
                    setIsEdit(true);
                    setModalVisibility("MAG_HOME_PAGE_PRODUCT_MODAL");
                  }}
                />
              </Flex>
            ),
          };
        }) || []
    );
  }, [data]);

  return (
    <Table
      locale={{ emptyText: "هیچ داده ای وجود ندارد" }}
      columns={MAG_HOME_PRODUCTS_COLUMN}
      dataSource={dataSource}
      loading={isPending}
      pagination={false}
    />
  );
};

export default HomeProductsTable;
